export default [
    {
        path: 'relatorio-consulta-solicitada',
        component: () => import(
            /* webpackChunkName: 'ambulatorio-relatorio-consulta-solicitada' */
            '@/views/ambulatorio/relatorio-consulta-solicitada/Index'
        ),
        redirect: 'relatorio-consulta-solicitada/index',
        children: [
            {
                name: 'ambulatorio-relatorio-consulta-solicitada-index',
                path: 'index',
                component: () => import(
                    /* webpackChunkName: 'ambulatorio-relatorio-consulta-solicitada' */
                    '@/views/ambulatorio/relatorio-consulta-solicitada/List.vue'
                ),
            },
        ],
    },
]